module.exports = __webpack_public_path__ + "static/media/Doga Tuncyuz.6c0317da.jpg";